module.exports = __webpack_public_path__ + "img/lecture-video-recorder.d982a700.jpg";